<style scoped>
.account-info-form-modal ::v-deep .account-info-form-wrapper {
    max-height: calc(100vh - 8rem);
    overflow: auto;
}
</style>
<template>
    <modal type="custom" class="modal-2xl account-info-form-modal">
        <accountInfoForm
            class="-mt-4 sm:mt-0"
            :showAgreePromotions="false"
            :formWrapper="bubbleBoxWrapper"
            :showBirthdayAwardMessage="false"
        >
            <template #buttons="{save, saveStatus}">
                <div class="flex justify-between mt-4 sm:pb-4">
                    <button
                        class="btn justify-center mr-2 w-1/2"
                        @click="$emit('hide')"
                    >
                        {{ $t('account.checkout.later') }}
                    </button>
                    <loadingButton
                        class="bg-primary ml-2 w-1/2 justify-center"
                        :status="saveStatus"
                        @click="save"
                        @successShown="$emit('success')"
                    >
                        {{ $t('account.checkout.filled') }}
                    </loadingButton>
                </div>
            </template>
        </accountInfoForm>
    </modal>
</template>

<script>
import bubbleBox from '@/components/bubbleBox.vue';
import modal from '@/components/modal.vue';
import accountInfoForm from '@/components/accountInfoForm.vue';
import loadingButton from '@/components/loadingButton.vue';
import img2s112 from '@/assets/img/2-112.png';

const bubbleBoxWrapper = {
    name: 'bubbleBoxWrapper',
    render(h) {
        return h(
            bubbleBox,
            {
                props: {
                    greetText: this.$t('account.checkout.greet'),
                    greetTextClass: 'text-darkGrayishBlue',
                    image: img2s112
                }
            },
            [h('div', { class: 'pt-4 px-4 sm:px-8' }, this.$slots.default)]
        );
    }
};

export default {
    components: {
        accountInfoForm,
        modal,
        loadingButton
    },
    computed: {
        bubbleBoxWrapper() {
            return bubbleBoxWrapper;
        }
    }
};
</script>
